import { ActionReference, DefaultGameState, GameObjectReference, GameState, QuestGameState } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";
// import { playerSession } from "../services/PlayerService";
// import { gameService } from "../../../api/src/game-implementation/services/GameService";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`
    :host {
        font-family: "Onesize";
        width: 100%;
        max-width: 1024px;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }

    .title {
        text-align: center;
        margin-top: 5px;
        overflow: auto;
        overflow-y: hidden
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 20px;
    }

    .header img {
    width: auto;
    height: 100%;
    image-rendering: pixelated;

    border: 3px solid #5c4934; 
    border-radius: 8px;
    background-color: #ffffff00; 
    box-shadow: 0 0 12px rgba(255, 184, 90, 0.2); 
    padding: 4px;
}


    .header img:nth-child(n + 2) {
        position: absolute
    }

    .map-container {
        position: absolute;
        top: 10px;
        left: 20px;
        text-align: center;
        border-radius: 5px;
        width: 100px;
        height: 100px;
    }
    .map-container:hover {
        border: white 1px solid;
        transition: ease-in 1s;
    }
    .map-container img {
        width: 100px;
        height: 100px;
        cursor: pointer;
    }

    .content {
        flex-grow: 1;
        overflow: auto;
        margin-top: 20px;
        padding: 20px 20px;

        background-color: rgba(30, 26, 22, 0.85); 
        color: #fffdf6; 

        line-height: 1.6;
        letter-spacing: 0.5px;

        border-radius: 12px;
        box-shadow: 0 0 12px rgba(255, 184, 90, 0.2); 
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;

}

    /* .inventorybutton {
    display: flex;
        flex-direction: column;
        overflow: auto;
        padding: 10px 10px 0 10px;
        position: left;
        color: green;
    } */
    
    .footer .button {
        background-color: #7f6ed7;
        border: 1px solid #332c57;
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
    }
.content p {
    margin: 0 0 10px 0;
}

.content p:last-of-type {
    margin: 0;
}

.footer {
    border-radius: 10px 10px 0 0;
    background-color: #1e1a16;
    border: 1px solid #5c4934; 
    margin-top: 14px;
    display: flex;
    height: auto;
}

.footer .buttons {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 10px 10px 0 10px;
}

.footer .button {
    background-color: #d6a34a; 
    border: 1px solid #5c4934;
    padding: 5px 10px;
    margin: 0 0 10px 10px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    user-select: none;
    color: #1a1008; 
    font-family: inherit;
    font-size: inherit;
}

.footer .button.active,
.footer .button:hover {
    background-color: #a96f2d; 
    color: #fffbea;
}




    .setting-container {
        position: absolute;
        top: 10px;
        right: 20px;
        text-align: center;
        border-radius: 5px;
        width: 46px;
        height: 46px;
    }
    .setting-container:hover {
        border: white 1px solid;
        transition: ease-in 1s;
    }
    .setting-container img {
        width: 45px;
        cursor: pointer;
    }

    dialog {
        width: 300px;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }
    .inventorybutton {
        position: relative;
        top: -10px;
        right: -450px;
        text-align: center;
        border-radius: 5px;
        width: 76px;
        height: 46px;
    }
    .inventory-container {
        position: absolute;
        top: 150px;
        left: 20px;
        text-align: center;
        border-radius: 5px;
        width: 100px;
        height: 100px;
    }
    .inventory-container:hover {
        border: white 1px solid;
        transition: ease-in 1s;
    }
    .inventory-container img {
        width: 100px;
        height: 100px;
        cursor: pointer;
    }

    h2 {
        margin-top: 0;
    }

    .settings-group {
        margin-bottom: 15px;
    }

    .settings-group label {
        display: block;
        margin-bottom: 5px;
    }

    .settings-group input {
        width: 100%;
        padding: 8px;
        border-radius: 4px;
        border: 1px solid #ccc;
        margin-left: -3px;
    }

    .button-group {
        display: flex;
        justify-content: space-between;
    }

    .button-group button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        background-color: #4caf50;
        color: white;
        cursor: pointer;
    }

    .button-group button:hover {
        background-color: #45a049;
    }

    game-settings{
        display: none

    }
    `;

/**
 * Represents the Canvas page
 */
export class CanvasComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;
    /** Current active action button */
    private _selectedActionButton?: ActionReference;
    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();
    // private _inventoryButton: HTMLElement;

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();
    }

    /**
     * Refresh the current game state
     */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
     * Update the canvas to the provided game state
     *
     * @param state Game state to update the canvas to
     */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Reset the component
        this._currentGameState = state;

        this._selectedActionButton = undefined;
        this._selectedGameObjectButtons.clear();

        // Refresh the web component
        void this.render();
    }

    /**
     * Render the contents of this page
     */
    private async render(): Promise <void> {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>

            ${this.renderTitle()}
            ${this.renderHeader()}
            ${await this.renderContent()}
            ${this.renderInventoryButton()}
            ${this.renderFooter()}
            ${this.renderMap()}
            ${this.renderSettingsButton()}
            ${this.renderDialog()}
            
            
            
            `;
            // <game-settings class"games-setting-style"></game-settings>

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    private renderMap(): HTMLElement {
        const element: HTMLElement = html`
            <div class="map-container">
                <img src="/assets/img/icon/map.png">
            </div>
        `;

        element.addEventListener("click", () => this._gameEventService.switchPage(Page.Map));

        return element;
    }

    /**
     * Render the title element
     *
     * @returns String with raw HTML for the title element. Can be empty.
     */
    private renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        if (roomName) {
            return `<div class="title">${roomName}</div>`;
        }

        return "";
    }

    /**
     * Render the header element
     *
     * @returns String with raw HTML for the header element. Can be empty.
     */
    private renderHeader(): string {
        const roomImages: string[] | undefined = this._currentGameState?.roomImages;

        if (roomImages && roomImages.length > 0) {
            return `
                <div class="header">
                    ${roomImages.map(url => `<img src="/assets/img/rooms/${url}.png" />`).join("")}
                </div>
            `;
        }

        return "";
    }

    /**
     * Render the content element
     *
     * @returns String with raw HTML for the content element
     */
    private async renderContent(): Promise<string> {
        if (this._currentGameState?.roomAlias === "Paintingroom1") {
            const questGame: QuestGameState = await this._gameRouteService.getQuestGameState();

            if (questGame.SnakePuzzleCompleted) {
                return `
                 <div class="content">
                    <mini-game></mini-game>
                </div>
                `;
            }
        }

        return `
            <div class="content">
                ${this._currentGameState?.text.map(text => `<p>${text}</p>`).join("") || ""}
            </div>
        `;
    }

    /**
     * Render the footer element
     *
     * @returns HTML element of the footer
     */
    private renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div>
                        ${this._currentGameState?.actions.map(button => this.renderActionButton(button))}
                    </div>
                    <div>
                        ${this._selectedActionButton
                            ? this._currentGameState?.objects.map(button =>
                                this.renderGameObjectButton(button)
                            ) || ""
                            : ""}
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * Render an Setting button for a given setting reference
     *
     * @returns HTML element of the setting button
     */

    private renderDialog(): HTMLElement {
        const element: HTMLElement = html`<game-settings></game-settings>`;
        return element;
    }

    private renderSettingsButton(): HTMLElement {
        const element: HTMLElement = html`
            <div class="setting-container">
                <img src="/assets/img/rooms/SettingIcon.png" alt="" />
            </div>
        `;

        element.addEventListener("click", () => {
            const dialogDiv: HTMLElement = this.shadowRoot?.querySelector(".game-style") as HTMLElement;
            // dialogDiv.style.visibility = "show";
            console.log(dialogDiv);
            const dialog: HTMLElement = this.shadowRoot?.querySelector("game-settings") as HTMLElement;
            dialog.style.display = "block";

            if (dialogDiv.style.visibility === "hidden") {
                dialogDiv.style.visibility = "show";
            }
        });

        return element;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderActionButton(button: ActionReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedActionButton === button ? "active" : ""}"> ${button.name} </a>
        `;

        element.addEventListener("click", () => this.handleClickAction(button));

        return element;
    }

    /**
     * Render a game object button for a given game object reference
     *
     * @returns HTML element of the game object button
     */
    private renderGameObjectButton(button: GameObjectReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedGameObjectButtons.has(button) ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickGameObject(button));

        return element;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderInventoryButton(): HTMLElement {
        const elements: HTMLElement = html`
            <div class="inventory-container">
                <img src="/assets/img/icon/inventory.png">
            </div>


        `;

        elements.addEventListener("click", () => this._gameEventService.switchPage(Page.Inventory));

        return elements;
    }

    /**
     * Handle the click on an action button
     *
     * @param button Action button that was clicked
     */
    private async handleClickAction(button: ActionReference): Promise<void> {
        // If this actions needs a game object, show the available game objects.
        if (button.needsObject) {
            this._selectedActionButton = button;
            this._selectedGameObjectButtons.clear();

            void this.render();

            return;
        }

        // Otherwise, execute the action and update the game state.
        const state: GameState | undefined = await this._gameRouteService.executeAction(button.alias);

        if (state === undefined) {
            return;
        }

        this.updateGameState(state);
    }

    /**
     * Handle the click on a game object button
     *
     * @param button Game object button that was clicked
     */
    private async handleClickGameObject(button: GameObjectReference): Promise<void> {
        // If no action button was clicked, do not try to handle this click.
        if (!this._selectedActionButton) {
            return;
        }

        // Add the game object to list of selected game objects
        this._selectedGameObjectButtons.add(button);

        // Try to execute the action with all game objects on the list
        const state: GameState | undefined = await this._gameRouteService.executeAction(
            this._selectedActionButton.alias,
            [...this._selectedGameObjectButtons].map(e => e.alias)
        );

        // If 2 more game objects where on the list, clear it.
        if (this._selectedGameObjectButtons.size >= 2) {
            this._selectedActionButton = undefined;
            this._selectedGameObjectButtons.clear();
        }

        // Refresh the web component
        void this.render();

        // If no state was returned, exit silently. This can happen when an action needs more than 1 game object.
        if (state === undefined) {
            return;
        }

        // Otherwise, update the game state.
        this.updateGameState(state);
    }
}
